export const YANDEX_METRIKA_ID = 11881159;

export const GA_COOKIE = '_ga';

export const YANDEX_METRIKA_COOKIE = '_ym_uid';

export const TRACKING_TIMESTAMP_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export const ECOMMERCE_CURRENCY_CODE = 'RUB';

export const ECOMMERCE_PRODUCT_CLICK_EVENT = 'productClick';

export const MINDBOX_OPERATIONS_URL = 'https://api.mindbox.ru/v3/operations/async';

export const MINDBOX_ENDPOINT_ID = 'travelata';

export const MINDBOX_DEVICE_UUID_POLL_MS = 500;

export const MINDBOX_DEVICE_UUID_WAIT_MS = 120_000;

export const MINDBOX_DATE_FORMAT = 'yyyy-MM-dd';

export const MINDBOX_INFANT_AGE = 0.5;

export const DATA_LAYER_IS_WL = 0;

export const DATA_LAYER_TOP_HOTELS_LIMIT = 20;

export const DATA_LAYER_TOP_HOTELS_TYPE = 'top20';

export const DATA_LAYER_BANNER_PLACEHOLDER_ID = 0;

export const DATA_LAYER_NO_OIL_TAX = 999_999;

export const DATA_LAYER_EXCLUSIVE_FILTER_TYPE = 'travelata_exclusive_only_regular_flights';

export const DATA_LAYER_HOTEL_CLASS_STARS: readonly number[] = [2, 3, 4, 5];

export const DATA_LAYER_DATE_FORMAT = 'dd-MM-yyyy';

export const DATA_LAYER_START_FORMAT = 'dd-MM-yyyy HH:mm';

export const DATA_LAYER_START_COOKIE = 'DataLayerAnalyticsStart';

export const DATA_LAYER_MAX_STEP_COOKIE = 'DataLayerAnalyticsMaxStep';

export const DATA_LAYER_GOOUT_BANNER_TYPE = 'gooutBanner';

export const SERP_CARD_CLICK_GOAL = 'serp_tour_card_click';

export const SERP_VERSION = 'new';
